{
    "Branding_Labels_BrandingEnabled": "Abilitare il branding per questo CME?",
    "Branding_Tab_Name_Colours": "Colori",
    "Branding_Tab_Name_AdditionalColours": "Altri colori",
    "Branding_Tab_Name_Imagery": "Immagini",
    "Branding_Tab_Name_Languages": "Lingua",
    "Branding_Tab_Name_SSOButtons": "Pulsanti SSO",
    "Branding_Tab_Name_Links": "Collegamenti",
    "Branding_Labels_DarkMode": "(Modalità oscura)",
    "Branding_Subtitles_ColourPalette": "Palette di colori",
    "Branding_Labels_PrimaryColour": "Primario",
    "Branding_Labels_SecondaryColour": "Secondario",
    "Branding_Labels_TertiaryColour": "Terziario",
    "Branding_Subtitles_HeaderSidebarColours": "Colori dell'intestazione\/barra laterale",
    "Branding_Labels_HeaderSidebarBackgroundColour": "Sfondo dell'intestazione\/barra laterale",
    "Branding_Labels_HeaderSidebarBackgroundContrastColour": "Accento intestazione\/barra laterale",
    "Branding_Labels_HeaderSidebarIconColour": "Icone intestazione\/barra laterale",
    "Branding_Subtitles_RouterColours": "Colori del router",
    "Branding_Labels_RouterLoaderBackgroundColour": "Sfondo del caricatore del router",
    "Branding_Labels_RouterLoaderForegroundColour": "Router Loader in primo piano",
    "Branding_Subtitles_DashboardColours": "Colori del cruscotto",
    "Branding_Labels_Dashboard_1_BgColour": "Dashboard 1 Sfondo",
    "Branding_Labels_Dashboard_1_FgColour": "Dashboard 1 in primo piano",
    "Branding_Labels_Dashboard_2_BgColour": "Sfondo del cruscotto 2",
    "Branding_Labels_Dashboard_2_FgColour": "Dashboard 2 in primo piano",
    "Branding_Labels_Dashboard_3_BgColour": "Sfondo del cruscotto 3",
    "Branding_Labels_Dashboard_3_FgColour": "Dashboard 3 in primo piano",
    "Branding_Labels_Dashboard_4_BgColour": "Dashboard 4 Sfondo",
    "Branding_Labels_Dashboard_4_FgColour": "Dashboard 4 in primo piano",
    "Branding_Labels_Dashboard_5_BgColour": "Dashboard 5 Sfondo",
    "Branding_Labels_Dashboard_5_FgColour": "Dashboard 5 in primo piano",
    "Branding_Labels_Dashboard_6_BgColour": "Dashboard 6 Sfondo",
    "Branding_Labels_Dashboard_6_FgColour": "Dashboard 6 in primo piano",
    "Branding_Subtitles_AuthColours": "Colori di autorizzazione",
    "Branding_Labels_Auth_Subtitle_HighlightColour": "Colore di evidenziazione dell'autorizzazione",
    "Branding_Subtitles_InsightsColours": "Insights Colori",
    "Branding_Labels_Insights_Stat_1_Colour": "Insights Stat 1",
    "Branding_Labels_Insights_Stat_2_Colour": "Insights Stat 2",
    "Branding_Labels_Insights_Stat_3_Colour": "Insights Stat 3",
    "Branding_Labels_Insights_Stat_4_Colour": "Insights Stat 4",
    "Branding_Labels_Insights_Stat_5_Colour": "Insights Stat 5",
    "Branding_Labels_Insights_Percentage_Increase": "Indicatore di cambiamento - Miglioramento",
    "Branding_Labels_Insights_Percentage_Decrease": "Indicatore di variazione - Declino",
    "Branding_Labels_Insights_Percentage_NoChange": "Nessun indicatore di cambiamento",
    "Branding_Labels_Insights_Quick_BusiestDay": "Approfondimenti Giorno più intenso",
    "Branding_Labels_Insights_Quick_BusiestTime": "Approfondimenti sul periodo di maggiore attività",
    "Branding_Labels_Highlights_MostCalled": "In evidenza Più Chiamati",
    "Branding_Labels_Highlights_MostAnsweredCalls": "In evidenza le chiamate più risposte",
    "Branding_Subtitles_CompanyLogos": "Loghi aziendali",
    "Branding_Labels_Imagery_MainLogo": "Logo principale (per sfondo scuro)",
    "Branding_Labels_Imagery_MainLogo_White": "Logo principale (su sfondo bianco)",
    "Branding_Labels_Imagery_Favicon": "Favicon (file .ico)",
    "Branding_Labels_Imagery_SquareLogo": "Logo quadrato",
    "Branding_Labels_Imagery_BroadworksLogo": "Logo di Broadworks",
    "Branding_Subtitles_Authorisation": "Immagini di autorizzazione",
    "Branding_Labels_Imagery_AuthBg": "Autorizzazione di sfondo (immagine o video)",
    "Branding_Subtitle_AuthLanguages": "Pagina di accesso",
    "Branding_Labels_AuthTitle": "Sottotitolo della pagina di accesso",
    "Branding_Labels_AuthTitle2": "Sottotitolo della pagina di accesso, riga 2",
    "Branding_Subtitle_Broadworks": "Broadworks",
    "Branding_Labels_BroadworksName": "Nome Broadworks",
    "Branding_Subtitle_SSOButtons": "Pulsanti SSO",
    "Branding_Labels_SSOIcon": "Icona",
    "Branding_Labels_SSOLabel": "Etichetta",
    "Branding_Labels_SSOUrl": "URL",
    "Branding_Labels_MainSiteLink": "Collegamento al sito principale",
    "Branding_Validation_MustBeValidURL": "Deve essere un URL valido",
    "Branding_SSO_Buttons_Add": "Aggiungi pulsante SSO",
    "Branding_SSO_Buttons_Remove": "Rimuovi pulsante SSO",
    "Branding_Labels_VanityURL": "URL",
    "Branding_ResetButton": "Ripristina alla versione precedente",
    "Branding_RestoreCurrentVersion": "Torna alla versione corrente",
    "Branding_ApplyPreviewButton": "Fai clic per visualizzare l'anteprima",
    "Branding_PreviewButton": "È disponibile una versione bozza. Clicca per l'anteprima",
    "Branding_DeletePreview": "Elimina anteprima",
    "Branding_UndoChanges": "Cancella le modifiche correnti",
    "Branding_Required_Message": "Questo campo è obbligatorio",
    "Branding_Submission_Line1": "Stiamo generando il tuo branding per te",
    "Branding_Submission_Line2": "Potrebbero volerci alcuni secondi",
    "Branding_Validation_MaxWordLength": "Nessuna parola singola deve superare i {} caratteri",
    "Branding_Validation_MaxLength": "Non deve superare i {} caratteri",
    "NAME": "BrandingLanguage"
}